import React from "react";

export const Header = ({ data }) => {
  return (
    <header id="header" className="hero-section">
      <div className="hero-copy">
        <p className="eyebrow">{data ? data.eyebrow : "Async Jam"}</p>
        <h1>{data ? data.title : "Designing and engineering useful things."}</h1>
        <p className="hero-lede">
          {data ? data.paragraph : "Loading the next odd little useful thing..."}
        </p>
        <div className="hero-actions">
          <a href="#projects" className="button-primary page-scroll">See the builds</a>
          <a href="#contact" className="button-secondary page-scroll">Start a conversation</a>
        </div>
      </div>

    </header>
  );
};
